export const infractionFields = [
    { name: "Infraction Type", format: "", type: "string" },
    { name: "cleaned_np", format: "", type: "string" },
    { name: "infraction_amount", format: "", type: "integer" },
    { name: "time", format: "YYYY-MM-DD HH:mm", type: "timestamp" },
    { name: "object_id", format: "", type: "string" },
    { name: "frame", format: "", type: "integer" },
    { name: "s3_path", format: "", type: "string" },
    { name: "latitude", format: "", type: "real" },
    { name: "longitude", format: "", type: "real" },
    { name: "insurance_infraction_flag", format: "", type: "integer" },
    { name: "elig_insur_infraction_amount", format: "", type: "integer" },
    { name: "rc_infraction_flag", format: "", type: "integer" },
    { name: "elig_rc_infraction_amount", format: "", type: "integer" },
    { name: "pucc_infraction_flag", format: "", type: "integer" },
    { name: "elig_pucc_infraction_amount", format: "", type: "integer" },
    { name: "permit_infraction_flag", format: "", type: "integer" },
    { name: "elig_permit_infraction_amount", format: "", type: "integer" },
    { name: "response_bodyresultvehiclecolour", format: "", type: "string" },
    { name: "response_bodyresultregauthority", format: "", type: "string" },
    { name: "response_bodyresultvehiclemanufacturername", format: "", type: "string" },
    { name: "response_bodyresultmodel", format: "", type: "string" },
    { name: "Vehicle Type", format: "", type: "string" }
];

export const municipalFields = [
    { name: "project_name", format: "", type: "string" },
    { name: "external_id", format: "", type: "string" },
    { name: "object_id", format: "", type: "string" },
    { name: "frame", format: "", type: "integer" },
    { name: "Infraction Type", format: "", type: "string" },
    { name: "s3_path", format: "", type: "string" },
    { name: "latitude", format: "", type: "real" },
    { name: "longitude", format: "", type: "real" },
    { name: "geohash8", format: "", type: "string" },
    { name: "time", format: "YYYY-MM-DD HH:mm", type: "timestamp" }
];

export const roadSignFields = [
    { name: "project_name", format: "", type: "string" },
    { name: "external_id", format: "", type: "string" },
    { name: "object_id", format: "", type: "string" },
    { name: "frame", format: "", type: "integer" },
    { name: "Road Sign Type", format: "", type: "string" },
    { name: "text", format: "", type: "string" },
    { name: "s3_path", format: "", type: "string" },
    { name: "driver_name", format: "", type: "string" },
    { name: "location_point", format: "", type: "string" },
    { name: "geohash8", format: "", type: "string" },
    { name: "latitude", format: "", type: "real" },
    { name: "longitude", format: "", type: "real" },
    { name: "time", format: "YYYY-MM-DD HH:mm", type: "timestamp" },
    { name: "icon", format: "", type: "string" }
];